/**
 * Aviso del backoffice que hay que leer antes de seguir: una accion que el
 * servidor rechazo (por ejemplo, destacar un producto con la portada llena).
 * Es un `Modal` y no `alert()`, por la misma regla que las confirmaciones.
 *
 * `mensaje` en `null` es cerrado: quien lo usa guarda solo el texto.
 */
import { Modal } from './Modal';

export interface ModalAvisoProps {
  titulo: string;
  mensaje: string | null;
  onCerrar(): void;
}

export function ModalAviso({ titulo, mensaje, onCerrar }: ModalAvisoProps) {
  return (
    <Modal titulo={titulo} abierto={mensaje !== null} onCerrar={onCerrar}>
      <div className="formulario-admin">
        <p role="alert">{mensaje}</p>
        <div className="modal-acciones">
          <button type="button" className="btn btn-primario" onClick={onCerrar}>
            Entendido
          </button>
        </div>
      </div>
    </Modal>
  );
}
